<template>
  <div>
    <div class="webinfo">
      <div class="webinfo_left">
        <!-- <div class="webinfo_left_info">
          <p>核心产品</p>
          <ul>
            <li>洞见AR</li>
            <li>洞见AR-World</li>
            <li>洞见AR小程序</li>
            <li>影见AR</li>
          </ul>
        </div>
        <div class="webinfo_left_info">
          <p>资源下载</p>
          <ul>
            <li>洞见SDK</li>
            <li>洞见AR-World SDK</li>
            <li>洞见AR眼镜SDK</li>
            <li>影见SDK</li>
            <li>山海镜APP</li>
            <li>洞见APP</li>
          </ul>
        </div> -->
        <div class="webinfo_left_info">
          <p>加入我们</p>
          <ul>
            <li>关于我们</li>
            <li>工作机会</li>
          </ul>
        </div>
        <div class="webinfo_left_info">
          <p>联系方式</p>
          <ul>
            <li>总部：佛山市高明区荷城街道沧江路385号金穗大厦六楼606室</li>
            <li>邮箱：928182187@qq.com</li>
            <li>电话：18038744392、13217605561</li>
            <li>
              <a
                href="https://beian.miit.gov.cn/"
                style="color: #fff; font-size: 18px"
                target="_blank"
                >粤ICP备2023067909号-1</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="webinfo_right">
        <img src="@/statis/imgs/802.png" alt="" />
        <!-- <img
          src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/ewm.png"
          alt=""
        />
        <p>官方微信</p> -->
      </div>
    </div>
    <div class="webInfoMobile">
      <div class="toTop" @click="backTop">回到顶部</div>
      <div class="webInfoMobile_list">
        <ul>
          <li @click="toExample">
            应用案列
            <img
              src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/pub/chevron-down-w.svg"
              alt=""
            />
          </li>
          <li @click="toAbout">
            联系方式
            <img
              src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/pub/chevron-down-w.svg"
              alt=""
            />
          </li>
          <li>
            <img src="@/statis/imgs/802.png" alt="" />
          </li>
          <li>
            <a
              href="https://beian.miit.gov.cn/"
              style="color: #fff; font-size: 18px"
              >粤ICP备2023067909号-1</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    backTop() {
      window.scrollTo(0, 0);
    },
    toAbout() {
      this.$router.push("/about");
    },
    toExample() {
      this.$router.push("/exampleList");
    },
  },
};
</script>

<style lang="less">
.webinfo {
  width: 100%;
  height: 35vw;
  background: #222226;
  display: flex;
  justify-content: center;
  align-items: center;

  &_left {
    width: 80%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &_info {
      width: 20%;
      height: 80%;

      p {
        width: 100%;
        height: 20%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #fff;
      }

      ul {
        width: 100%;
        height: 80%;
        display: flex;
        justify-content: start;
        flex-direction: column;

        li {
          width: 100%;
          height: 10%;
          margin-top: 1vw;
          display: flex;
          justify-content: start;
          align-items: center;
          color: #c6bebe;
          cursor: pointer;
          text-align: left;
          font-size: 13px;

          &:hover {
            color: #ffffff;
          }
        }
      }

      &:last-child {
        width: 25%;
      }
    }
  }

  &_right {
    width: 20%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 55%;
      height: 8%;
      margin-top: 20%;

      &:nth-child(2) {
        width: 30%;
        height: 18%;
      }
    }

    p {
      width: 100%;
      height: 10%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }
  }
}
.webInfoMobile {
  display: none;
}
@media (max-width: 550px) {
  .webinfo {
    display: none;
  }
  .webInfoMobile {
    display: block;
    width: 100%;
    height: 100vw;
    background: #121213;

    .toTop {
      width: 100%;
      height: 13%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-bottom: 1px solid rgba(215, 211, 211, 0.285);
      font-size: 4vw;
    }

    ul {
      width: 90%;
      height: auto;

      li {
        width: 100%;
        height: 15vw;
        margin-left: 5%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        border-bottom: 1px solid rgba(222, 218, 218, 0.138);
        font-size: 3.4vw;

        &:nth-child(1),
        &:nth-child(2) {
          img {
            transform: rotate(-90deg);
          }
        }

        &:nth-child(3) {
          box-sizing: border-box;
          padding: 14vw 0;

          img {
            width: 60%;
          }
        }

        &:nth-child(4) {
          border: none;
          font-size: 5vw;
        }
      }
    }
  }
}
</style>
